import React from 'react';
import { ActionButton, Tooltip, TooltipTrigger } from '@adobe/react-spectrum';
import styles from './Row.module.scss';

interface KeyDateTitleWithTooltipProps {
  title: string;
}

// Helper component to show tooltip only when text is longer than 19 characters
export const KeyDateTitleWithTooltip: React.FC<
  KeyDateTitleWithTooltipProps
> = ({ title }) => {
  const showTooltip = title.length > 16;
  const content = (
    <ActionButton
      isQuiet
      UNSAFE_className={`${styles.keyDateTitle} ${
        showTooltip
          ? styles.keyDateTitleWithTooltip
          : styles.keyDateTitleNoTooltip
      }`}
    >
      {title}
    </ActionButton>
  );

  if (showTooltip) {
    return (
      <TooltipTrigger delay={0}>
        {content}
        <Tooltip>{title}</Tooltip>
      </TooltipTrigger>
    );
  }

  return content;
};
